import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { getProgramById } from '../../data/programs';
export function KidsMartialArtsPage() {
  const program = getProgramById('kids-martial-arts');
  if (!program) {
    return null;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-887">
      <Header data-id="element-888" />

      <main className="pt-20" data-id="element-889">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-20" data-id="element-890">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-891">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-892">
              {program.name}
            </h1>
            <p className="text-lg text-slate-200 max-w-2xl" data-id="element-893">
              {program.description}
            </p>
          </div>
        </section>

        {/* Placeholder Content */}
        <section className="py-16 bg-white" data-id="element-894">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-895">
            <div className="aspect-video rounded-xl overflow-hidden mb-8" data-id="element-896">
              <img src={program.image} alt={program.name} className="w-full h-full object-cover" data-id="element-897" />
            </div>

            <div className="prose max-w-none" data-id="element-898">
              <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-899">
                Program Details Coming Soon
              </h2>
              <p className="text-slate-600" data-id="element-900">
                Detailed information about our {program.name} program will be
                added here soon. Please contact us for more information about
                this program.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-901" />
    </div>;
}